
export const fetchClustersByAppointment = async (apptId, userID, signal) => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/clusters/${apptId}?username=${userID}`, {
    signal,
  });
  if (!response.ok) {
    throw new Error("Failed to fetch clusters data");
  }
  return response.json();
};